import { render, staticRenderFns } from "./importMercadoErros.vue?vue&type=template&id=24511240"
import script from "./importMercadoErros.vue?vue&type=script&lang=js"
export * from "./importMercadoErros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports